/* eslint-disable no-extra-parens */
export default function hasKeyboardModifier (e, {
	alt = true,
	ctrl = true,
	meta = true,
	shift = true
} = {}) {
	return (
		(e.altKey && alt) ||
		(e.ctrlKey && ctrl) ||
		(e.metaKey && meta) ||
		(e.shiftKey && shift)
	);
};
